import { showNotify } from 'vant';

export function parseFileSize(size) {
	if (size < 1024) {
		return size + "B";
	} else if (size < 1024 * 1024) {
		return (size / 1024).toFixed(2) + "KB";
	} else {
		return (size / (1024 * 1024)).toFixed(2) + "MB";
	}
}

export function formatData(s) {
	if (!s) return " - ";
	const d = new Date(s);
	return d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + d.getDate();
}

//Element Tree 根据 id，查出关联 id
export function findRelatedId(id, tree) {
	var res = tree.find((item) => item.id == id);
	if (res !== undefined) return [id];
	var reult = null;
	tree.map((item) => {
		const res = (item.children || []).find((i) => i.id == id);
		if (res !== undefined) reult = [item.id, id];
	});
	return reult;
}

export function deepCopy(obj, hash = new WeakMap()) {
	// 处理基本类型和 null/undefined
	if (obj === null || typeof obj !== "object") {
		return obj;
	}

	// 处理日期对象
	if (obj instanceof Date) {
		return new Date(obj);
	}

	// 处理正则表达式
	if (obj instanceof RegExp) {
		return new RegExp(obj);
	}

	// 处理循环引用
	if (hash.has(obj)) {
		return hash.get(obj);
	}

	// 处理数组和对象
	const copy = Array.isArray(obj)
		? []
		: Object.create(Object.getPrototypeOf(obj));
	hash.set(obj, copy);

	for (let key in obj) {
		if (obj.hasOwnProperty(key)) {
			copy[key] = deepCopy(obj[key], hash);
		}
	}

	// 处理 Symbol 属性
	const symbolKeys = Object.getOwnPropertySymbols(obj);
	for (let symKey of symbolKeys) {
		copy[symKey] = deepCopy(obj[symKey], hash);
	}

	return copy;
}

export function downloadFile(url, filename) {
	// 创建一个隐藏的<a>元素
	const link = document.createElement("a");
	link.style.display = "none";

	// 设置下载属性
	link.href = url;
	// link.target = "blank";

	// 如果提供了文件名，则设置download属性
	if (filename) {
		link.download = filename;
	}

	// 添加到DOM中
	document.body.appendChild(link);

	// 触发点击事件
	link.click();

	// 移除元素
	document.body.removeChild(link);
}

export function copyToClipboardLegacy(text) {
	// // 找不到复制对象
	if (!text) return ElMessage.error("复制失败：内容为空");
	// 创建临时textarea元素
	const textarea = document.createElement("textarea");
	textarea.value = text;

	// 设置样式使其不可见
	textarea.style.position = "fixed";
	textarea.style.top = "0";
	textarea.style.left = "0";
	textarea.style.opacity = "0";

	// 添加到DOM
	document.body.appendChild(textarea);

	// 选中文本
	textarea.select();
	textarea.setSelectionRange(0, 99999); // 移动设备支持

	try {
		// 执行复制命令
		const successful = document.execCommand("copy");
		if (successful) {
			// console.log("复制成功");
			ElMessage.success("复制成功");
		} else {
			// console.log("复制失败")
			ElMessage.error("复制失败");
		}
		return successful;
	} catch (err) {
		console.error("复制失败:", err);
		return false;
	} finally {
		// 清理DOM
		document.body.removeChild(textarea);
	}
}

/**
 * 动态加载 JavaScript 文件
 * @param {string} url - 要加载的脚本URL
 * @param {function} [callback] - 加载成功后的回调函数
 * @param {function} [errorCallback] - 加载失败时的回调函数
 * @returns {HTMLElement} 创建的 script 元素
 */
export function loadScript(url, callback, errorCallback) {
	// 创建 script 元素
	const script = document.createElement("script");
	script.type = "text/javascript";
	script.src = url;
	script.async = true;

	// 加载成功处理
	script.onload = function () {
		if (typeof callback === "function") {
			callback();
		}
	};

	// 加载错误处理
	script.onerror = function () {
		if (typeof errorCallback === "function") {
			errorCallback(new Error(`Failed to load script: ${url}`));
		}
	};

	// 添加到文档中
	document.head.appendChild(script);

	return script;
}

/**
 * 时间戳转时间
 * @param {timeStamp} 时间戳
 * @param {format} 时间格式
 * @returns {string} 对应时间格式的时间
 */
export function timeStampFormat(timeStamp, format = "YYYY-MM-DD HH:mm:ss") {
	if (!timeStamp) return "-";
	const date = new Date(timeStamp);
	const year = date.getFullYear();
	let month = date.getMonth() + 1;
	month = month < 10 ? "0" + month : month;
	let day = date.getDate();
	day = day < 10 ? "0" + day : day;
	let hour = date.getHours();
	hour = hour < 10 ? "0" + hour : hour;
	let minute = date.getMinutes();
	minute = minute < 10 ? "0" + minute : minute;
	let second = date.getSeconds();
	second = second < 10 ? "0" + second : second;
	switch (format) {
		case "YYYY-MM-DD":
			return `${year}-${month}-${day}`;
		default:
			return `${year}-${month}-${day} ${hour}:${minute}:${second}`;
	}
}

// 定义一个函数来请求全屏
export function openFullscreen() {
    const elem = document.documentElement
    if (elem.requestFullscreen) {
        elem.requestFullscreen(); // 标准方法
    } else if (elem.mozRequestFullScreen) { /* Firefox */
        elem.mozRequestFullScreen(); // Firefox
    } else if (elem.webkitRequestFullscreen) { /* Chrome, Safari & Opera */
        elem.webkitRequestFullscreen(); // Chrome, Safari 和 Opera
    } else if (elem.msRequestFullscreen) { /* IE/Edge */
        elem.msRequestFullscreen(); // IE/Edge
    }
}

// 定义一个函数来退出全屏
export function closeFullscreen() {
  if (document.exitFullscreen) {
    document.exitFullscreen(); // 标准方法
  } else if (document.mozCancelFullScreen) { /* Firefox */
    document.mozCancelFullScreen(); // Firefox
  } else if (document.webkitExitFullscreen) { /* Chrome, Safari and Opera */
    document.webkitExitFullscreen(); // Chrome, Safari 和 Opera
  } else if (document.msExitFullscreen) { /* IE/Edge */
    document.msExitFullscreen(); // IE/Edge
  }
}

/**
 * 将富文本内容转化成普通字符串
 * @param {string} html - 富文本HTML内容
 * @param {object} options - 配置选项
 * @param {boolean} options.keepLineBreak - 是否保留换行符，默认true
 * @param {boolean} options.trim - 是否去除首尾空格，默认true
 * @param {number} options.maxLength - 最大长度限制，0表示不限制
 * @returns {string} 普通字符串
 */
export function richTextToPlainText(html, options = {}) {
	if (!html || typeof html !== 'string') {
		return ''
	}

	const {
		keepLineBreak = true,
		trim = true,
		maxLength = 0
	} = options

	// 创建一个临时的div元素
	const tempDiv = document.createElement('div')
	tempDiv.innerHTML = html

	// 处理换行标签
	if (keepLineBreak) {
		// 将块级元素替换为换行符
		tempDiv.innerHTML = tempDiv.innerHTML
			.replace(/<\/p>/gi, '\n')
			.replace(/<\/div>/gi, '\n')
			.replace(/<br\s*\/?>/gi, '\n')
			.replace(/<\/li>/gi, '\n')
			.replace(/<\/h[1-6]>/gi, '\n')
	}

	// 获取纯文本内容
	let text = tempDiv.textContent || tempDiv.innerText || ''

	// 处理换行符
	if (keepLineBreak) {
		// 将多个连续的换行符替换为单个换行符
		text = text.replace(/\n{3,}/g, '\n\n')
	} else {
		// 移除所有换行符和多余空格
		text = text.replace(/\s+/g, ' ')
	}

	// 去除首尾空格
	if (trim) {
		text = text.trim()
	}

	// 限制最大长度
	if (maxLength > 0 && text.length > maxLength) {
		text = text.substring(0, maxLength) + '...'
	}

	return text
}

/**
 * 格式化价格
 * @param {*} price string|number
 * @returns string
 */
export const formatPrice = (price) => {
  if (!price) return '￥0.00';
  return `￥${(Number(price)/100).toFixed(2)}`;
}


export function copyToClipboard(text) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text).then(() => {
            showNotify({ type: 'success', message: '复制成功！' })
        }).catch(() => {
            fallbackCopy(text)
        })
    } else {
        fallbackCopy(text)
    }
}

function fallbackCopy(text) {
    const textarea = document.createElement('textarea')
    textarea.value = text
    textarea.style.position = 'fixed'
    textarea.style.opacity = '0'
    document.body.appendChild(textarea)
    textarea.select()
    try {
        document.execCommand('copy')
        showNotify({ type: 'success', message: '复制成功！' })
    } catch (err) {
        showNotify({ type: 'danger', message: '复制失败，请手动复制' })
    }
    document.body.removeChild(textarea)
}